import './scss/main-emory.scss';
import './js/index-emory.js';

// Fonts
import './fonts/founders-grotesk-text-bold-italic.woff2';
import './fonts/founders-grotesk-text-bold.woff2';
import './fonts/founders-grotesk-text-light-italic.woff2';
import './fonts/founders-grotesk-text-light.woff2';
import './fonts/founders-grotesk-text-medium-italic.woff2';
import './fonts/founders-grotesk-text-medium.woff2';
import './fonts/founders-grotesk-text-regular-italic.woff2';
import './fonts/founders-grotesk-text-regular.woff2';
import './fonts/founders-grotesk-text-semibold-italic.woff2';
import './fonts/founders-grotesk-text-semibold.woff2';

import './fonts/0a117c53-f4e9-4c12-b950-f8e97196946c.woff';
import './fonts/0e5e27ca-33a6-4ea0-a6ab-06024df16108.woff';
import './fonts/25eb220a-d147-4053-ba76-47a8ac4cbf87.woff2';
import './fonts/29358dc9-0521-4b0e-9024-d71728007f09.woff';
import './fonts/36d6862f-906f-4738-be47-01d3f7671fe4.woff';
import './fonts/4c7a94e1-4cd8-455d-8976-7e0620cbe015.woff2';
import './fonts/5b946d7f-128b-4120-987c-04b99b2b7c72.woff';
import './fonts/80ea1ca6-34b3-4198-96a3-34b006e9a97c.woff2';
import './fonts/85fb2a3e-84d3-4bcb-8d5b-a461c702db8f.woff';
import './fonts/9f01bfe7-0e03-437b-a7ee-2832b3d8cdc7.woff2';
import './fonts/fcb40e0a-2b58-4233-b6c1-eb0a3dd29b8f.woff2';
import './fonts/faa7d663-b043-4d89-83bf-ae6a1192f25f.woff2';


// Images
import './images/availability-widget-bg.png';
import './images/riviera-logo-black.svg';
import './images/riviera-logo.svg';
import './images/riviera-wide-logo.png';
import './images/riviera-logo-wide.svg';
import './images/asterisk.svg';
import './images/hotel-panorama.jpg';
import './images/bookingblockold.png';
import './images/bookingblock.png';
import './images/bookingblock@2x.png';
import './images/explore-arrow.svg';
import './images/placeholders/landscape-placeholder1.jpg';
import './images/placeholders/landscape-placeholder2.jpg';
import './images/placeholders/square-placeholder1.jpg';
import './images/placeholders/square-placeholder2.jpg';
import './images/placeholders/floor-plan-placeholder.jpg';
import './images/placeholders/card.jpg';

import './images/header/book.svg';
import './images/header/close.svg';
import './images/header/hamburger.svg';
import './images/header/placeholder-megamenu.png';

import './images/icons/facebook.svg';
import './images/icons/twitter.svg';
import './images/icons/instagram.svg';
import './images/icons/phone.svg';
import './images/icons/phone-white.svg';
import './images/icons/phone2.svg';
import './images/icons/grid.svg';
import './images/icons/mail.svg';
import './images/icons/map-pin.svg';
import './images/arrow-left.svg';
import './images/arrow-right.svg';